import { AutocompleteNoOptions, FormField } from '@dev-spendesk/grapes';
import cx from 'classnames';
import type { FormikProps } from 'formik';
import { Trans } from 'react-i18next';

import { AutocompleteSearch } from 'common/components/AutocompleteSearch';
import { useTranslation } from 'common/hooks/useTranslation';
import type { FormValues } from 'modules/bookkeep/settings/export/components/TemplateEditorForm/formValues';

import { useAccountingSoftwareOptions } from './useAccountingSoftwareOptions';

type Props = Pick<
  FormikProps<FormValues>,
  'values' | 'errors' | 'setFieldValue'
> & {
  visuallyHideLabel?: boolean;
};

export const AccountingSoftwareField = ({
  values,
  errors,
  setFieldValue,
  visuallyHideLabel,
}: Props) => {
  const { t } = useTranslation('global');
  const availableAccountingSoftwares = useAccountingSoftwareOptions();

  return (
    <div className={cx(visuallyHideLabel && 'flex-col', 'flex gap-x-24')}>
      <FormField
        label={t('exports.accountingSoftwareNameLabel')}
        className="mb-16 w-[436px]"
        visuallyHideLabel={visuallyHideLabel}
        alertMessage={errors.accountingSoftware}
      >
        <AutocompleteSearch
          showClearSelectionButton
          value={
            values.accountingSoftware
              ? {
                  key: values.accountingSoftware,
                  label:
                    values.accountingSoftware === 'Other'
                      ? t('exports.accountingsSoftwareOther')
                      : values.accountingSoftware,
                }
              : undefined
          }
          fit="parent"
          options={availableAccountingSoftwares}
          isInvalid={!!errors.accountingSoftware}
          placeholder={t('exports.accountingSoftwareNamePlaceholder')}
          onSelect={(accountingSoftware) => {
            setFieldValue('accountingSoftware', accountingSoftware?.key);
          }}
          renderNoOptions={(search) => (
            <AutocompleteNoOptions className="p-4">
              <>
                <p className="mb-8">
                  <Trans
                    i18nKey="exports.errors.unknownAccountingSoftware.noResults"
                    values={{ search }}
                    components={{
                      em: <strong className="title-m" />,
                    }}
                  />
                </p>
                <p>
                  <Trans
                    i18nKey="exports.errors.unknownAccountingSoftware.tooltip"
                    values={{ others: t('exports.accountingsSoftwareOther') }}
                    components={{
                      em: <strong className="title-m" />,
                    }}
                  />
                </p>
              </>
            </AutocompleteNoOptions>
          )}
        />
      </FormField>
    </div>
  );
};
